// extracted by mini-css-extract-plugin
export default {"root":"EditorBanner_root__WZpup","wide":"EditorBanner_wide__eL29L","kuShare":"EditorBanner_kuShare__Mf3hO","card":"EditorBanner_card__Z78Gf"};